function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["use-state-with-callback"] = e(require("react")) : t["use-state-with-callback"] = e(t.react);
}(window, function (t) {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var u = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(u.exports, u, u.exports, r), u.l = !0, u.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var u in t) r.d(n, u, function (e) {
        return t[e];
      }.bind(null, u));
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 1);
  }([function (e, r) {
    e.exports = t;
  }, function (t, e, r) {
    "use strict";

    r.r(e), r.d(e, "useStateWithCallbackInstant", function () {
      return o;
    });
    var n = r(0);

    function u(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        var r = [],
            n = !0,
            u = !1,
            o = void 0;

        try {
          for (var i, c = t[Symbol.iterator](); !(n = (i = c.next()).done) && (r.push(i.value), !e || r.length !== e); n = !0);
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            n || null == c.return || c.return();
          } finally {
            if (u) throw o;
          }
        }

        return r;
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var o = function o(t, e) {
      var r = u(Object(n.useState)(t), 2),
          o = r[0],
          i = r[1];
      return Object(n.useLayoutEffect)(function () {
        return e(o);
      }, [o, e]), [o, i];
    };

    e.default = function (t, e) {
      var r = u(Object(n.useState)(t), 2),
          o = r[0],
          i = r[1];
      return Object(n.useEffect)(function () {
        return e(o);
      }, [o, e]), [o, i];
    };
  }]);
});